import Header from "../Header/Header";
import Main from "../Main/Main";

const Layout = () => {
  return (
    <>
      <Header />
      <Main />
    </>
  );
};

export default Layout;
